import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import { lowerCase } from 'lodash'
import notDisplayWidgetHomePageHelp from 'assets/pictures/observatory/notDisplayWidgetHomePageHelp.webp'
import widgetPublicTokenHelp from 'assets/pictures/observatory/widgetPublicTokenHelp.webp'
import useDebounce from 'utils/customHook/useDebounce'
import { WIDGET } from '../../ObservatoryConstants'
import { Grid, Typography } from '@mui/material'
import HelpParameter from '../HelpParameter'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'

const WidgetPublicToken = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = [],
    getGlobalModuleParameter = () => {},
    isGlobal = false,
}) => {
    const {
        applicativeUsers,
    } = useSelector(store => ({
        applicativeUsers: store.UserReducer.applicativeUsers,
    }), shallowEqual)

    const parameter = 'widgetPublicToken'
    const otherParameter = 'widgetPublicLogin'
    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [widgetPublicToken, setWidgetPublicToken] = useState(foundParameter)
    const [moduleWidgetPublicToken, setModuleWidgetPublicToken] = useState(foundModuleParameter)

    const widgets = applicativeUsers.filter(({ isApplicative, login }) => isApplicative && lowerCase(login).includes(WIDGET.conventionalName))

    useDebounce(() => {
        const widgetPublicLogin = widgets.find(w => w.token === widgetPublicToken)?.login
        const widgetPublicLoginParam = widgetPublicLogin ? getGlobalParameter(otherParameter, widgetPublicLogin) : {}
        setParameters(prev => [
            ...prev.filter(p => ![parameter, otherParameter].includes(p.parameter)),
            getGlobalParameter(parameter, widgetPublicToken),
            widgetPublicLoginParam,
        ])
    }, 200, [widgetPublicToken])

    useDebounce(() => {
        const moduleWidgetPublicLogin = widgets.find(w => w.token === moduleWidgetPublicToken)?.login
        const moduleWidgetPublicLoginParam = moduleWidgetPublicLogin ? getGlobalModuleParameter(otherParameter, moduleWidgetPublicLogin) : {}
        setModuleParameters(prev => [
            ...prev.filter(p => ![parameter, otherParameter].includes(p.parameter)),
            getGlobalModuleParameter(parameter, moduleWidgetPublicToken),
            moduleWidgetPublicLoginParam,
        ])
    }, 200, [moduleWidgetPublicToken])

    return (
        <Grid container justifyContent='space-between' alignItems='center' columnSpacing={1}>
            <Grid size={0.5}>
                <HelpParameter image={widgetPublicTokenHelp} />
            </Grid>
            <Grid container size='grow'>
                <Typography variant='normalFormTitle'>{i18n.publicWidget}</Typography>
            </Grid>
            <Grid size={3.25}>
                <SuperMultiAutocomplete
                    options={widgets}
                    values={widgetPublicToken}
                    onChange={setWidgetPublicToken}
                    keyLabel='login'
                    keyValue='token'
                    disabled={!isGlobal}
                />
            </Grid>
            {!isGlobal && (
                <Grid size={3.25}>
                    <SuperMultiAutocomplete
                        options={widgets}
                        values={moduleWidgetPublicToken}
                        onChange={setModuleWidgetPublicToken}
                        keyLabel='login'
                        keyValue='token'
                    />
                </Grid>
            )}
            <Grid size={0.5} />
        </Grid>
    )
}

WidgetPublicToken.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    isGlobal: PropTypes.bool,
}

const WidgetParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => (
    <ParameterCard title={i18n.widget} isGlobal={isGlobal}>
        <ParameterWithSwitch
            {...defaultProps}
            parameter='notDisplayWidgetHomePage'
            title={i18n.startOnPublicWidget}
            helpImage={notDisplayWidgetHomePageHelp}
            invertValue
        />
        <WidgetPublicToken {...defaultProps} />
        <ParameterWithSimpleInput
            {...defaultProps}
            parameter='managerUrl'
            title={i18n.managerUrl}
            placeholder='https://example.fr/'
        />
    </ParameterCard>
)

WidgetParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default WidgetParameters
